import uuid from 'react-uuid';
import { encryptPayload, getCurrentPage, getMetaData } from './util';

const verifyClicCase = async (params) => {
  const {
    dataObj, journeyId, iformIntegrationUrls, pageType, searchUrlType, cuid,
  } = params;

  const clicPayload = {
    head: {
      traceId: uuid(),
      span: 'span',
      journeyId,
    },
    body: {
      ...dataObj,
    },
  };

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: encryptPayload(clicPayload),
  };
  let finalResponse = {};
  const page = getCurrentPage();
  const res = await fetch(`${iformIntegrationUrls}/iForms/${pageType}/oneclic/${searchUrlType}/request?cuid=${cuid}${page ? `&page=${page}` : ''}`, requestOptions);
  if (res.ok) {
    const data = await res.json();
    finalResponse = { ...data };
  } else {
    finalResponse = {
      statusIndicator: 'F',
      statusCode: res.status,
      message: res.statusText,
    };
  }
  return finalResponse;
};

/* eslint complexity: ["error", 51] -- need to increase complexity */
export const handleClicApiCall = async ({
  formContainer, formSubmissionPayload, selectedMemberInfo,
  setFormSubmissionPayload, iformIntegrationUrls, contextVal,
  handleContinue, searchUrlType, journeyId, loggerApiCall, setDynamicClicDetails,
  setIsFormSubmission,
}) => {
  setIsFormSubmission(true); // disable the button once the api is called
  let clicCaseVerifyOperations = null;

  if (formContainer.operations
    && formContainer.operations.clickCaseVerify) {
    clicCaseVerifyOperations = formContainer.operations.clickCaseVerify;
  }

  // Read searchType and isNestedClicResponse from clickCaseVerify if present,
  // otherwise fall back to onClic for backward compatibility with other forms (e.g. merchantKYC)
  const onClic = formContainer.operations && formContainer.operations.onClic;
  const searchType = (clicCaseVerifyOperations && clicCaseVerifyOperations.searchType)
    || (onClic && onClic.searchType)
    || 'static';
  // clicBody retains onClic for any extra fields (e.g. marketName) used by non-KYC forms
  const clicBody = onClic || {};

  /* eslint-disable no-extra-parens -- need */
  const referenceIdentifier = formSubmissionPayload.cardNumber
    || (selectedMemberInfo && selectedMemberInfo.accountToken);
  const defaultNumberOfDigits = (selectedMemberInfo && selectedMemberInfo.accountToken)
    ? 15 : (referenceIdentifier ? referenceIdentifier.length : 0);

  // If requestKeys defined in clickCaseVerify, build payload from only those keys
  const requestKeys = clicCaseVerifyOperations && clicCaseVerifyOperations.requestKeys;
  let dataObj = requestKeys
    ? getMetaData(requestKeys, { formSubmissionPayload, selectedMemberInfo })
    : {
      caseNumber: formSubmissionPayload.caseNumber,
      referenceIdentifier,
      ...clicBody,
      startFrom: clicCaseVerifyOperations && clicCaseVerifyOperations.partOfCard
        ? clicCaseVerifyOperations.partOfCard : 0,
      /**
       * pass number of digits mentioned in JSON
       * if not mentioned --> if secure form then pass 15
       * otherwise pass the lenth of referenceIdentifier
       */
      numberOfDigits: clicCaseVerifyOperations && clicCaseVerifyOperations.cardNumberLength
        ? Math.abs(clicCaseVerifyOperations.cardNumberLength)
        : defaultNumberOfDigits,
      isSubsetReq: clicCaseVerifyOperations && clicCaseVerifyOperations.isSubsetReq
        ? clicCaseVerifyOperations.isSubsetReq : false,
    };
  /* eslint-enable no-extra-parens -- need */

  /**
   * if it's a secure form --> we have to pass accountToken to get correct account number in backend
   * secure forms won't be validated against the referenceIdentifier passed from UI
   * only applies when requestKeys is not defined; otherwise accountToken can be
   * declared in requestKeys
   */
  if (!requestKeys && selectedMemberInfo && selectedMemberInfo.accountToken) {
    dataObj = { ...dataObj, accountToken: selectedMemberInfo.accountToken };
  }

  let logString = 'status=calledClicSearchApi';
  loggerApiCall(logString, 'info');
  const rawData = await verifyClicCase({
    dataObj,
    journeyId,
    iformIntegrationUrls,
    pageType: formContainer.pageType,
    searchUrlType,
    cuid: contextVal.cuid,
  });

  // Normalize nested clic response format when configured via
  // clickCaseVerify.isNestedClicResponse: true
  let data = rawData;
  if (clicCaseVerifyOperations?.isNestedClicResponse && rawData && rawData.cases_search_response) {
    const csr = rawData.cases_search_response;
    const firstCase = csr.cases_list && csr.cases_list[0];
    data = {
      statusIndicator: csr.success_indicator,
      statusCode: csr.status_code,
      message: csr.message_detail_text,
      caseStatusText: firstCase && firstCase.case_status_text,
      assignedTo: firstCase && firstCase.assigned_to,
      lastPendNote: firstCase && firstCase.LastPendNote,
      referenceIdentifier: firstCase && firstCase.reference_identifier,
    };
  }

  setIsFormSubmission(false); // enable the button once the call is successfull
  if (data.statusIndicator === 'T') {
    logString = 'status=ClicSearchApiCallSuccess';
    loggerApiCall(logString, 'info');
    const { caseStatusText } = data;
    let caseStatusToLookFor = ['CS-0000', 'Open', 'Pending-FurtherInformation', 'Re-Open', 'Pending-AwaitingDocuments'];// default case list
    let clicCaseStatusToMoveToErrorPage = null;
    let statusErrorPage = null;
    let clicWorkBasketToLookFor;

    if (clicCaseVerifyOperations) {
      if (clicCaseVerifyOperations.clicCaseStatusToLookFor) {
        caseStatusToLookFor = clicCaseVerifyOperations.clicCaseStatusToLookFor;
      }
      if (clicCaseVerifyOperations.clicCaseStatusToMoveToErrorPage) {
        clicCaseStatusToMoveToErrorPage = clicCaseVerifyOperations.clicCaseStatusToMoveToErrorPage;
      }
      if (clicCaseVerifyOperations.clicWorkBasketToLookFor) {
        clicWorkBasketToLookFor = clicCaseVerifyOperations.clicWorkBasketToLookFor;
      }
    }

    if (clicWorkBasketToLookFor && clicWorkBasketToLookFor.indexOf(data.assignedTo) === -1) {
      // validate the clic case is valid access to this jounrey
      loggerApiCall(`${logString} errorMsg=case is assigned to ${data.assignedTo}`, 'error');
      setFormSubmissionPayload({
        ...formSubmissionPayload,
        ...{
          elemId: null, wbMatchStatus: 0, cardMatchStatus: 1, cardNameVerify: 1,
        },
      });
    } else if (!(caseStatusToLookFor.indexOf(caseStatusText) >= 0)) {
      if (clicCaseStatusToMoveToErrorPage) {
        /* eslint-disable no-restricted-syntax -- need */
        for (const statusErrorCase of clicCaseStatusToMoveToErrorPage) {
          if (statusErrorCase.status.indexOf(caseStatusText) >= 0) {
            statusErrorPage = statusErrorCase.errorPage;
            break;
          }
        }
        /* eslint-enable no-restricted-syntax -- need */
      }
      if (statusErrorPage) {
        handleContinue(statusErrorPage);
      } else {
        setFormSubmissionPayload({
          ...formSubmissionPayload,
          ...{ elemId: null, caseStatusMatch: 0 },
        });
      }
    } else if (searchType === 'static') {
      handleContinue();
    } else {
      /* dynamic clic logic */
      const { lastPendNote } = data;
      if (lastPendNote) {
        setDynamicClicDetails(lastPendNote);
        setFormSubmissionPayload({
          ...formSubmissionPayload,
          ...{
            elemId: 'continue',
            dynamicClicDetails: lastPendNote,
          },
        });
      } else {
        setFormSubmissionPayload({
          ...formSubmissionPayload,
          ...{ elemId: null, dataToDisplay: 0 },
        });
      }
    }
  } else {
    loggerApiCall(`status=ClicSearchApiCallFailed errorMsg=${data.message} status=${data.statusCode}`, 'error');
    setFormSubmissionPayload({
      ...formSubmissionPayload,
      ...{ elemId: null, cardMatchStatus: 0, cardNameVerify: 0 },
    });
  }
};
